import { alertError } from 'src/store/alert/actions';
import { apiUrl } from './../../index';
import axios, { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { ClosureActionTypes } from './types';
import fileDownload from 'js-file-download';

export const executeClosure = (successCB: () => any) => {
  const fetchRequest = () => action(ClosureActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: any) => action(ClosureActionTypes.FETCH_SUCCESS, { data });
  const fetchError = (error: Error) => action(ClosureActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .post(apiUrl + '/closure/')
      .then((res: AxiosResponse) => {
        fileDownload(res.data, 'Jahresabschluss.csv');
        dispatch(fetchSuccess(res.data));
        successCB();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/closure/actions.ts